/** Whether the viewer asked for less motion. With it on, cards show their finished frame, silently. */

export function prefersReducedMotion(): boolean {
  return typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
